import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetIncidentConfigurationsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetIncidentConfigurations`
});

export const DeleteIncidentConfigurationRequest = (configurationName, id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/DeleteIncidentConfiguration`,
	params: { configurationName, id }
});

export const AddIncidentConfigurationRequest = (item) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/CreateIncidentConfiguration`,
	data: item
});

export const UpdateIncidentConfigurationRequest = (item) => AxiosRequest({
	method: 'PUT',
	url: `${config.API_URL}IncidentTracker/UpdateIncidentConfiguration`,
	data: item
});

export const IsSafeToDeleteConfigurationRequest = (configurationName, id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/IsSafeToDeleteConfiguration`,
	params: { configurationName, id }
});
